export const palette = {
  id: 'oldGlory',
  displayName: 'Old Glory',
  graph: {
    writeSample: '#DC143C', writeTrend: 'rgba(220, 20, 60, 0.67)',
    writeMax: '#FF6B6B', writeMin: '#8B0000', writeLatency: '#DC143C',
    readSample: '#3C3B6E', readTrend: 'rgba(60, 59, 110, 0.67)',
    readMax: '#7878B4', readMin: '#1A1940', readLatency: '#3C3B6E',
  },
  canvas: {
    chartBg: '#FFFFFF', gridColor: '#E0E0E0', textColor: '#3C3B6E',
  },
};

const oldGlory = {
  id: 'oldGlory',
  displayName: 'Old Glory',
  baseType: 'light',
  enabled: false,
  linkedPalette: 'oldGlory',
  palette,
  ui: {
    headerBg: '#FFFFFF', headerText: '#3C3B6E', accentColor: '#B22234',
    mainBg: '#EEF2FF', mainText: '#3C3B6E', mainTextHeading: '#3C3B6E',
    mainHeroText: '#FFFFFF', footerBg: '#FFFFFF', footerText: '#3C3B6E',
    cardBg: '#FFFFFF', cardText: '#3C3B6E', cardBorder: '#3C3B6E',
    cardButtonBg: '#3C3B6E', cardButtonText: '#FFFFFF',
    navLinkText: '#3C3B6E', navLinkHover: '#B22234', navLinkActive: '#3C3B6E',
    listGroupBg: '#EEF2FF', bmrkDetailBg: '#3C3B6E',
    bmrkMetricBg: '#FFFFFF', bmrkMetricText: '#3C3B6E', bmrkMetricBorder: '#3C3B6E',
    mainCardText: '#3C3B6E', navLinkFocus: '#3C3B6E', navEmailActive: '#3C3B6E',
    homeProseLabel: '#B22234', homeProseLink: '#3C3B6E', homeProseDlBtn: '#3C3B6E',
    cardButtonBorder: '#3C3B6E', linkColor: '#B22234', cardTextMuted: '#65648C',
  },
};
export default oldGlory;
